import { useTranslation } from 'react-i18next';
import { PrivacyPolicyES } from './PrivacyPolicyES';
import { PrivacyPolicyEN } from './PrivacyPolicyEN';
import { PrivacyPolicyIT } from './PrivacyPolicyIT';

export function PrivacyPolicy() {
  const { i18n } = useTranslation();

  if (i18n.language.startsWith('en')) {
    return <PrivacyPolicyEN />;
  }

  if (i18n.language.startsWith('it')) {
    return <PrivacyPolicyIT />;
  }

  // Fallback to Spanish (the legally binding original language)
  return <PrivacyPolicyES />;
}
